/**
 * Auto-advance customer reviews slider (matches theme SliderComponent next behavior).
 */
(function () {
  const AUTO_MS = 3000;

  function setup(root) {
    const component = root.querySelector('slider-component');
    const slider = component && component.querySelector('[id^="Slider-"]');
    const nextBtn = component && component.querySelector('button[name="next"]');
    if (!slider || !nextBtn) return;

    let timer;

    function step() {
      if (nextBtn.hasAttribute('disabled')) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        nextBtn.click();
      }
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(step, AUTO_MS);
    }

    function stop() {
      clearInterval(timer);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    start();
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
  }

  document.querySelectorAll('.customer-reviews-slider').forEach((root) => {
    if (root.dataset.reviewsAutoplayInit) return;
    root.dataset.reviewsAutoplayInit = 'true';
    setup(root);
  });
})();

